import { CheckboxField, DropdownField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../common/state';
import { EElevators } from '../../../../json_query';
import { changeElevators, changeServiceLiftCheckbox } from '../../../state/advanced/elevators';
import { InlineBlock, InlineParam, Row } from '../markup';

export interface IElevatorsProps {
  elevatorsCount: EElevators;
  onElevatorsChanged(value: EElevators): void;

  hasServiceLift: boolean;
  onChangedCheckbox(value: boolean): void;
}

export const elevators: React.StatelessComponent<IElevatorsProps> = props => (
  <Row title="Лифтов минимум">
    <InlineBlock>
      <DropdownField
        value={props.elevatorsCount}
        onValueChange={(value: EElevators) => props.onElevatorsChanged(value)}
        values={[
          { value: EElevators.Any, label: 'Неважно' },
          { value: EElevators.One, label: '1' },
          { value: EElevators.Two, label: '2' },
          { value: EElevators.Three, label: '3' },
          { value: EElevators.Four, label: '4' },
        ]}
      />
    </InlineBlock>
    <InlineParam>
      <CheckboxField
        label={`Есть грузовой`}
        value={props.hasServiceLift}
        onValueChange={value => props.onChangedCheckbox(value)}
      />
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    elevatorsCount: (state.filters.jsonQuery.lifts && state.filters.jsonQuery.lifts.value) || EElevators.Any,
    hasServiceLift: !!(state.filters.jsonQuery.lift_service && state.filters.jsonQuery.lift_service.value.gte),
  }),
  (dispatch: Dispatch) => ({
    onElevatorsChanged: (value: EElevators) => {
      dispatch(changeElevators(value));
    },
    onChangedCheckbox: (value: boolean) => {
      dispatch(changeServiceLiftCheckbox(value));
    },
  }),
)(elevators);
